/* Actions */
import { baseActionName } from "./actions";

/* Utils */
import { makeFetchReducers } from "../../utils";

export default makeFetchReducers(baseActionName, []);
